import React, { useState } from 'react';

/** Paste WhatsApp / voice scribe transcript into EMR */
export default function WhatsappScribePanel({ value, onChange, onApplyToComplaint, readOnly }) {
  const [raw, setRaw] = useState(value || '');

  const parse = () => {
    const text = raw.trim();
    onChange?.(text);
    if (onApplyToComplaint && text) {
      const lines = text.split('\n').filter(Boolean);
      const complaint = lines.find((l) => !l.startsWith('Dr') && l.length > 10) || lines[0] || text.slice(0, 200);
      onApplyToComplaint(complaint);
    }
  };

  return (
    <div className="card" style={{ borderLeft: '4px solid #25d366', marginBottom: 12 }}>
      <h4 style={{ margin: '0 0 8px', color: '#128c7e' }}>Voice / WhatsApp scribe</h4>
      <p className="hint" style={{ fontSize: 11 }}>Paste dictation from WhatsApp or voice notes. Click Apply to merge into chief complaint.</p>
      <textarea className="input" rows={4} value={raw} readOnly={readOnly} onChange={(e) => setRaw(e.target.value)} placeholder="Paste scribe transcript here…" />
      {!readOnly && (
        <button type="button" className="btn btn-sm btn-secondary" style={{ marginTop: 8 }} onClick={parse}>Apply scribe</button>
      )}
    </div>
  );
}
